import { DashboardState, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import React from "react";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import ComponentToolKit from "./component-toolkit/component-toolkit";

interface IComponentListProps {}

const ComponentList: React.FC<IComponentListProps & IWithSDProps> = ({ sd }) => {
  const isComponentsPanelVisible = sd.getVisibility(ViewPart.ComponentsPanel) === Visibility.Visible;

  if (!isComponentsPanelVisible) {
    return null;
  }

  return (
    <>
      {sd.dashboardState === DashboardState.design && (
        <ComponentToolKit sd={sd} project={sd.project} designType="screen" />
      )}
      {sd.dashboardState === DashboardState.reportDesigner && (
        <ComponentToolKit sd={sd} project={sd.project} designType="report" />
      )}
    </>
  );
};

const componentList = withSD<IComponentListProps>(ComponentList);
export { componentList as ComponentList };
